import { Autocomplete, Button, Chip, Grid, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useImmer } from "use-immer";
import DataTable from "../DataGrid/DataGrid";
import { GridColDef } from "@mui/x-data-grid";
import {
  APP_BASE_URL,
  extractFilters,
  GET_SCHEDULE_CODE_LIST,
  UNHEALTHY_ASSET_REPORT,
} from "../../Common/EndPoints";
import axios from "axios";
import toast from "react-hot-toast";
import { getLocalStorage, getParsedLocalStorage } from "../../Utils/storage-utils";
import { extractAllowedUserRoleList, extractUserDataFromPermission } from "../../Utils/Utils";
import dayjs from "dayjs";
import { getDeviceTypes } from "../Devices/Devices";
import { periodicityOptions } from "../Form Assignment/AssignmentForm/AssignmentForm";
import { DatePicker } from "antd";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";
import "./mis.scss"
import { useSearchParams } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";

const { RangePicker } = DatePicker;

const unhealthyAssetColumns: GridColDef[] = [
  {
    field: "gearOrAssetType",
    headerName: "Asset Type",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "software",
    headerName: "System",
    sortable: true,
    minWidth: 100,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => params?.value?.code,
    renderCell: (params) => params?.value?.code,
  },
  {
    field: "scheduleCode",
    headerName: "Schedule Code",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "periodicity",
    headerName: "Periodicity",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
    // renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "maintainer",
    headerName: "Maintainer",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "gearNameOrNumber",
    headerName: "Asset Name / Number",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "scheduleDate",
    headerName: "Schedule Date",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
    renderCell: (params) => {
      return params?.value ? dayjs(params?.value).format("DD-MM-YYYY") : "";
    },
  },
  {
    field: "maintenanceCompletionDate",
    headerName: "Maintenance Completion Date",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
    renderCell: (params) => {
      return params?.value ? dayjs(params?.value).format("DD-MM-YYYY") : "";
    },
  },
  {
    field: "criticalCount",
    headerName: "Critical Counts",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "warningCount",
    headerName: "Warning Counts",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "assetHealth",
    headerName: "Asset Health",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "assetCode",
    headerName: "Asset Code",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "station",
    headerName: "Station",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "division",
    headerName: "Division",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
  {
    field: "zone",
    headerName: "Zone",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
  },
];

const initialState = {
  data: [],
  totalElements: 0,
};

const initialFilters = {
  // division: "",
  // section: "",
  customerIds: [],
  gearNameorNumber: "",
  assetType: "",
  scheduleCode: "",
  maintainer: [],
  periodicity: "",
  AssetHealth: "",
  maintenanceStart_ts: null,
  maintenanceEnd_ts: null,
  systems: [],
};

function UnhealthyAssetReport() {
  const [searchParams] = useSearchParams();
  const { customerNameToIdObject: customer_name_to_id } = usePermissions();
  const [state, setState] = useImmer(initialState);
  const stationId = searchParams.get("stn_codes");
  const assetHealth = searchParams.get("assetHealth");
  const assetType = searchParams.get("deviceType");
  const [filter, setFilter] = useState({
    ...initialFilters,
    customerIds: stationId?.split?.(",").map((station: any) => customer_name_to_id[station]) || [],
    AssetHealth: assetHealth || "",
    assetType: assetType || "",
  });
  const [unhealthyAssetTableLoader, setUnhealthyAssetTableLoader] = useState(false);

  useEffect(() => {
    getUnhealthyAsset();
  }, [filter]);

  const getFilterFormatted = (filter: any) => {
    let _filter: any = { ...filter, softwareIds: filter.systems.map((system: any) => system.systemId) };
    delete _filter["systems"];
    if (_filter?.maintenanceStart_ts) {
      _filter.maintenanceStart_ts = dayjs(_filter.maintenanceStart_ts).valueOf();
    }
    if (_filter?.maintenanceEnd_ts) {
      _filter.maintenanceEnd_ts = dayjs(_filter.maintenanceEnd_ts).valueOf();
    }
    _filter.customerIds = _filter?.customerIds?.toString() ?? null;
    // delete _filter["customerId"];
    return _filter;
  }

  const getUnhealthyAsset = async () => {
    try {
      setUnhealthyAssetTableLoader(true);
      let _filter = getFilterFormatted(filter);
      // _filter.customerId = _filter?.customerId?.[0] ?? null;
      _filter = extractFilters(_filter);

      const url = `${APP_BASE_URL}${UNHEALTHY_ASSET_REPORT}?${_filter}`;
      const res = await axios.get(url);
      if (res?.data?.data?.content) {
        setState((state) => {
          state.data = res.data.data.content;
          state.totalElements = res.data.data?.totalElements || 0;
        });
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong");
        return;
      }
      console.log("UNHEALTHY_ASSET_ERROR", error)
      toast.error("Something went wrong");
    } finally {
      setUnhealthyAssetTableLoader(false);
    }
  };

  const filterTableData = (filter: any) => {
    setFilter((oldFilter) => ({
      ...oldFilter,
      ...filter,
      // page: 0,
    }));
  };

  return (
    <div className="page-container--card">
      <div className="flex justify-between">
        <Typography variant="h6" sx={{ fontWeight: "bold" }} textAlign={"start"}>
          Maintenance Deficiency
        </Typography>
      </div>

      <UnhealthyAssetFilter filter={filter} onFilter={filterTableData} initialFilters={initialFilters} />

      <DataTable
        tableInfo={{
          id: `codal-life-expired-asset-table`,
          label: `Codal Life Expired Asset`,
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        loading={unhealthyAssetTableLoader}
        rows={state.data}
        columns={unhealthyAssetColumns}
        rowCount={state.totalElements}
        hideExportPDF={true}
        getRowId={(row) => row.id + row?.maintenanceCompletionDate}
      />
    </div>
  );
}

export default UnhealthyAssetReport;

const UnhealthyAssetFilter = ({
  filter,
  onFilter,
  initialFilters,
}: {
  filter: any;
  onFilter: any;
  initialFilters: any;
}) => {
  const [privateFilter, setPrivateFilter] = useImmer(filter);
  const [gearTypeList, setGearTypeList] = useState([]);
  const onChangeFilter = (name: any, value: any) => {
    setPrivateFilter((draft: any) => {
      draft[name] = value;
    });
  };
  const [scheduleCodes, setScheduleCodes] = useState([]);

  useEffect(() => {
    if (privateFilter?.assetType) {
      getScheduleCode(privateFilter?.assetType);
    }
  }, [privateFilter?.assetType]);

  const { innerToCustomers } = usePermissions();

  const system_options = useMemo(() => {
    const systems = getParsedLocalStorage("systems_list", []);
    return systems.map((system: any) => ({
      systemId: system.id,
      systemName: system.code,
    }));
  }, []);

  // const filteredSections = useMemo(() => {
  //   return divisionLists?.[privateFilter?.division] || [];
  // }, [privateFilter?.division]);

  useEffect(() => {
    const filteredStations = privateFilter.customerIds.filter((stn: any) =>
      Object.values(innerToCustomers).flat().find((station: any) => station.customerId === stn)
    );
    setPrivateFilter((draft: any) => {
      draft.customerIds = filteredStations;
    });

    if (privateFilter.customerIds.length !== filteredStations.length) {
      onFilter({
        ...privateFilter,
        customerIds: filteredStations,
      });
    }
  }, [innerToCustomers]);

  const filteredStations = useMemo(() => {
    return (Object.values(innerToCustomers) || [])?.flat?.()?.map((station: any) => {
      return {
        value: station.customerId,
        label: station.customerName,
      };
    });
  }, [innerToCustomers]);

  useEffect(() => {
    handleFetchDeviceTypeList();
  }, []);

  async function handleFetchDeviceTypeList() {
    const _device_type_list = await getDeviceTypes();
    setGearTypeList(_device_type_list);
  }

  const userRoles = useMemo(() => {
    let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies") || "{}");
    let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
    return allowedRoleIdList;
  }, []);

  const getScheduleCode = async (typeId: string) => {
    let url = `${APP_BASE_URL}${GET_SCHEDULE_CODE_LIST}`;
    let params = {
      deviceTypeId: typeId,
      scheduleCodeMapingOnly: true,
    };
    try {
      const res = await axios.get(url, { params });
      let RESPONSE = res.data.data;
      let ddList = RESPONSE.map((val: any) => {
        return { key: val.id, value: val.code };
      });

      setScheduleCodes(ddList);
    } catch (error) {
      setScheduleCodes([]);
    }
  };

  return (
    <div className="filters-container">
      {/* <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={divisions}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Select Division" placeholder="Select Division" />
        )}
        getOptionLabel={(option) => {
          return option;
        }}
        isOptionEqualToValue={(option, value) => option === value}
        value={divisions.find((option: any) => option === privateFilter?.division) || null}
        onChange={(_, newValue) => {
          onChangeFilter("division", newValue || "");
          onChangeFilter("section", "");
          onChangeFilter("customerId", "");
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={filteredSections}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Select Section" placeholder="Select Section" />
        )}
        // getOptionLabel={(option) => {
        //   return option;
        // }}
        isOptionEqualToValue={(option, value) => option === value}
        value={filteredSections.find((option: any) => option === privateFilter?.section) || null}
        onChange={(_, newValue) => {
          onChangeFilter("section", newValue || "");
          onChangeFilter("customerId", "");
        }}
      /> */}

      <Autocomplete
        size="small"
        multiple
        disableCloseOnSelect
        className="filter-input auto-complete"
        options={filteredStations}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Stations" placeholder="Stations" />
        )}
        getOptionLabel={(option) => {
          return option.label;
        }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={filteredStations.filter((option: any) => privateFilter?.customerIds?.includes(option.value)) || []}
        onChange={(_, newValue) => {
          onChangeFilter("customerIds", newValue?.map((val: any) => val.value) || []);
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].label} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.label ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />

      {/* <Grid item xs={6} md={4} lg={3}>
        <TextField
          fullWidth
          size="small"
          className="filter-input"
          label="Asset Code"
          placeholder="Asset Code"
          name="assetCode"
          value={privateFilter?.assetCode || ""}
          onChange={(e) => {
            onChangeFilter(e.target.name, e.target.value);
          }}
        />
      </Grid> */}

      <Autocomplete
        className="filter-input auto-complete"
        size="small"
        multiple
        disableCloseOnSelect
        limitTags={2}
        isOptionEqualToValue={(option, value) => option.systemId === value.systemId}
        getOptionKey={(option) => option.systemId}
        value={privateFilter.systems ?? []}
        options={system_options}
        getOptionLabel={(option) => option.systemName}
        onChange={(_, value) =>
          onChangeFilter("systems", value || [])
        }
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].systemName} {...getTagProps({ index: 0 })} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
        renderInput={(params) => <TextField {...params} label="Systems" placeholder="Systems" />}
      />

      <TextField
        fullWidth
        size="small"
        className="filter-input"
        label="Asset / Equipment Name or Number"
        placeholder="Asset / Equipment Name or Number"
        name="gearNameorNumber"
        value={privateFilter?.gearNameorNumber || ""}
        onChange={(e) => {
          onChangeFilter(e.target.name, e.target.value);
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={gearTypeList}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Select Asset Type" placeholder="Select Asset Type" />
        )}
        getOptionLabel={(option: any) => {
          return option.label;
        }}
        isOptionEqualToValue={(option: any, value: any) => option.typeid === value.typeid}
        value={gearTypeList.find((option: any) => option.typeid === privateFilter?.assetType) || null}
        onChange={(_, newValue) => {
          onChangeFilter("assetType", newValue?.typeid || "");
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={scheduleCodes}
        renderInput={(params) => <TextField className="filter-input" {...params} label="Select Schedule Code" />}
        getOptionLabel={(option: any) => option.value}
        isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
        value={scheduleCodes.find((option: any) => option.key === privateFilter?.scheduleCode) || null}
        onChange={(_, newValue) => {
          onChangeFilter("scheduleCode", newValue?.key || "");
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        disableCloseOnSelect
        multiple
        options={userRoles}
        renderInput={(params) => (
          <TextField className="filter-input" {...params} label="Select Maintainer" placeholder="Select Maintainer" />
        )}
        getOptionLabel={(option: any) => {
          return option.value;
        }}
        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
        value={userRoles.filter((option: any) => privateFilter?.maintainer?.includes(option.id))}
        onChange={(_, newValue) => {
          onChangeFilter("maintainer", newValue.map((val) => val.id) || []);
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((val) => val?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={periodicityOptions}
        renderInput={(params) => <TextField className="filter-input" {...params} label="Select Periodicity" />}
        getOptionLabel={(option: any) => option.value}
        isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
        value={periodicityOptions.find((option) => option.key === privateFilter?.periodicity) || null}
        onChange={(_, newValue) => {
          onChangeFilter("periodicity", newValue?.key || "");
        }}
      />

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={["Healthy", "Unhealthy"]}
        renderInput={(params) => <TextField className="filter-input" {...params} label="Select Asset Health" />}
        getOptionLabel={(option) => {
          return option;
        }}
        isOptionEqualToValue={(option, value) => option === value}
        value={["Healthy", "Unhealthy"].find((option) => option === privateFilter?.AssetHealth) || null}
        onChange={(_, newValue) => {
          onChangeFilter("AssetHealth", newValue || "");
        }}
      />

      {/* <Autocomplete
          size="small"
          className="filter-input auto-complete"
          disableCloseOnSelect
          options={[]}
          renderInput={(params) => (
            <TextField
              className="filter-input"
              {...params}
              label="Select Maintenance Period"
              placeholder="Select Maintenance Period"
            />
          )}
          getOptionLabel={(option) => {
            return option;
          }}
          isOptionEqualToValue={(option, value) => option === value}
          value={[].find((option) => option === privateFilter?.maintenancePeriod) || null}
          onChange={(_, newValue) => {
            onChangeFilter("maintenancePeriod", newValue || "");
          }}
        /> */}
      <RangePicker
        className="filter-input"
        value={[privateFilter?.maintenanceStart_ts || null, privateFilter?.maintenanceEnd_ts || null]}
        onChange={(dates) => {
          if (dates && dates[0] && dates[1]) {
            onChangeFilter("maintenanceStart_ts", dates[0]);
            onChangeFilter("maintenanceEnd_ts", dates[1]);
          }
        }}
        placeholder={["Expired Date From", "Expired Date To"]}
        size="large"
      />

      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button variant="contained" onClick={() => onFilter(privateFilter)}>
          Filter
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            onFilter(initialFilters);
            setPrivateFilter(initialFilters);
          }}
        >
          Clear
        </Button>
      </Stack>
    </div>
  );
};
